import { useCallback, useEffect, useState } from "react";
import ReactFocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { Modal, ValidateCode } from "@/shared/ui";
import useGoogleCode from "@/domains/playerMenu/hooks/useGoogleCode";
import useGameSettings from "@/domains/settings/hooks/useGameSettings";
import PlayerMenuSettingsSafetyResetTfaAutheticatorContainer from "@/domains/playerMenu/containers/settings/safety/tfa/reset-tfa/PlayerMenuSettingsSafetyResetTfaAutheticatorContainer";

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyDisableTfaAuthenticatorContainer({
  onClose,
}: Props) {
  const [authCode, setAuthCode] = useState("");
  const [isRecoveryCode, setIsRecoveryCode] = useState(false);
  const { checkCodeHandler, checkIsPending, checkError, checkIsCompleted } = useGoogleCode();
  const { getGameSettings } = useGameSettings();

  const onSubmit = useCallback(async () => {
    checkCodeHandler(authCode, false);
  }, [authCode]);

  const closeHandler = useCallback(() => {
    getGameSettings();
    onClose();
  }, [checkIsCompleted, onClose]);

  useEffect(() => {
    if (checkIsCompleted) {
      closeHandler();
    }
  }, [checkIsCompleted, closeHandler]);

  const onResetAccess = useCallback(() => {
    setIsRecoveryCode(true);
  }, []);

  const backToInputGoogleCode = useCallback(() => {
    setIsRecoveryCode(false);
  }, []);

  const title = isRecoveryCode ? "Нет доступа к Authenticator" : "Отключение 2FA Authenticator";

  if (checkIsCompleted) {
    return null;
  }

  return (
    <Modal open onClose={onClose} title={title} className="h-[49rem]">
      <ReactFocusLock className="grow flex flex-col w-full h-full">
        {isRecoveryCode ? (
          <PlayerMenuSettingsSafetyResetTfaAutheticatorContainer
            onBack={backToInputGoogleCode}
            onClose={closeHandler}
          />
        ) : (
          <ValidateCode
            onSubmit={onSubmit}
            type={TfaMethod.AUTHENTICATOR}
            description="Введите 6-значный код из вашего приложения"
            address=""
            onSendCode={() => {}}
            code={authCode}
            onCodeChange={setAuthCode}
            pending={checkIsPending}
            sendCodePending={false}
            error={checkError}
            onResetAccess={onResetAccess}
          />
        )}
      </ReactFocusLock>
    </Modal>
  );
}
